module.exports = __webpack_public_path__ + "static/img/arrow_left_w.266fd7ec.svg";